import { Controller } from "@hotwired/stimulus"

// Selects an input's whole value on focus/click, so tapping a set field lets you
// immediately type a new number instead of having to clear it first.
export default class extends Controller {
  select(event) {
    const el = event.target
    // Defer: on mobile/Safari the click can place the caret after focus, deselecting.
    requestAnimationFrame(() => el.select())
  }
}
